export enum Layouts {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
